<!-- 添加/编辑 敏感词分类弹框组件 -->
<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      width="500px"
      style="margin-top:12vh;"
      class="option-dialog"
      :close-on-click-modal="false"
    >
      <div slot="title">{{ type == 1 ? "分类" : "编辑分类" }}</div>
      <el-form
        :model="showParams"
        ref="SensitiveWordForm"
        label-width="110px"
        class="xForm"
        center
      >
        <el-form-item label="分类名称" prop="wordTypeName">
          <el-input
            clearable
            size="medium"
            v-model="showParams.wordTypeName"
            autocomplete="off"
            maxlength="30"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="涉及范围" prop="userId" class="el-tags-wrap">
          <el-tag
            style="margin-right:4px"
            v-for="item in userMembenNames"
            :key="item.id"
            closable
            type="small"
            @close="delSelectedHandle(item)"
          >
            {{ item.name }}
          </el-tag>
          <el-button type="text" @click="clickAddMember()" class="tags-btn">{{
            userMenberList.length != 0 ? "修改" : "添加"
          }}</el-button>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancel" style="margin-right:20px"
          >取消</el-button
        >
        <el-button type="primary" size="small" @click="confirm">确定</el-button>
      </div>
    </el-dialog>
    <!-- 添加人员树 -->
    <!-- <AddMemberView :title="title" :dialogVisibleTree="dialogVisibleTree" :currentSelectMember='userMenberList' @closeTree='closeTree' @clickSubmitTree='clickSubmitTree'></AddMemberView> -->
    <StaffTree
      title="添加成员"
      :dialogVisibleTree="dialogVisibleTree"
      :currentSelectMember="userMenberList"
      @closeTree="closeTree"
      @clickSubmitTree="clickSubmitTree"
    ></StaffTree>
  </div>
</template>

<script>
import {
  addSensitiveWordType,
  updateSensitiveWordType,
} from "@/api/senWord/senWord.js";
import { getOrganization } from "@/api/staffTree/staffTree.js";
// import AddMemberView from "@/views/code/components/addMember.vue"
import StaffTree from "@/components/staffTree/staffTree.vue";
export default {
  name: "optionSensitiveWordTypeDialog",
  components: {
    // AddMemberView,
    StaffTree,
  },
  data() {
    return {
      showParams: {
        wordTypeName: "",
        userId: [],
      },
      dialogVisible: false,
      addParams: {
        wordTypeName: "", // 分类名字
        userId: [], // 涉及范围内员工Id
      },
      editPatams: {
        typeId: "",
        wordTypeName: "",
        userId: [],
      },
      userMembenNames: [],
      userMenberList: [], //  当前选中的成员（成员数返回的数据）
      title: "选择员工", // 成员数标题
      dialogVisibleTree: false, //  成员数可见与否
      type: 1, // 新增 1 / 编辑 2
      allStaff: [], // 所有员工的数据
    };
  },
  async created() {
    // let tree1 = this.$store.state.tagsView.tree1
    // if(tree1 && tree1.length !=0) {
    //   this.allStaff = tree1.empList
    // }else {
    await this.getDepartStaff();
    // }
  },
  methods: {
    //获取所有员工&部门
    async getDepartStaff() {
      let params = {
        mark: 2,
      };
      await getOrganization(params, localStorage.getItem("Authorization"))
        .then((res) => {
          if (res.error.code == 200) {
            this.$store.dispatch("tagsView/setTree1", res.data);
            this.allStaff = res.data.empList;
          }
        })
        .catch((err) => {});
    },
    //对象数组去重(根据userId去重)
    getArrSet(Arr, id) {
      var obj = {};
      const arrays = Arr.reduce((setArr, item) => {
        obj[item[id]] ? "" : (obj[item[id]] = true && setArr.push(item));
        return setArr;
      }, []);
      return arrays;
    },
    // 树关闭
    closeTree(val) {
      this.dialogVisibleTree = false;
    },
    //获取显示的人员数据
    getUsersNameData(data) {
      let memberList = JSON.parse(JSON.stringify(data));
      this.userMembenNames = [];
      memberList.map((v) => {
        this.userMembenNames.push({
          treeId: v.id, //树id
          id: v.userId ? v.userId : v.departmentId,
          name: v.userName ? v.userName : v.departmentName,
          type: v.userId ? "per" : "depart",
        });
      });
      this.userMembenNames = this.getArrSet(this.userMembenNames, "id");
    },
    // 重置数据
    resetParams() {
      this.showParams = {
        wordTypeName: "",
        userId: [],
      };
      this.userMenberList = [];
      this.userMembenNames = [];
    },
    // 成员树的事件
    clickSubmitTree(val) {
      this.userMenberList = val.currentMember;
      this.showParams.userId = [];
      this.userMembenNames = JSON.parse(JSON.stringify(val.currentIdName));
      let arr = JSON.parse(JSON.stringify(val.sendArray));
      arr.forEach((item) => {
        this.showParams.userId.push(item.userId);
      });
      this.dialogVisibleTree = false;
    },
    // 确定事件
    confirm() {
      if (this.showParams.wordTypeName && this.showParams.userId.length != 0) {
        if (this.type == 1) {
          // 新增分类确定事件
          this.addSensitiveWordType(this.showParams);
        } else {
          // 编辑分类确定事件
          this.$confirm("您确定修改该分类？提交后将无法撤回", {
            distinguishCancelAndClose: true,
            closeOnClickModal: false,
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            iconClass: "el-icon-warning",
            customClass: "delete-messege",
            center: true,
          })
            .then((res) => {
              this.updateSensitiveWordType(this.showParams);
            })
            .catch((action) => {
              this.$message("取消编辑");
            });
        }
      } else {
        this.$message.warning("表单字段不能为空！");
      }
    },
    // 取消事件
    cancel() {
      this.resetParams();
      this.dialogVisible = false;
    },
    // 删除选中的成员
    delSelectedHandle(data) {
      //过滤原始数据
      this.userMenberList = this.userMenberList.filter((v) => {
        return v.departmentId != data.id && v.userId != data.id;
      });
      //过滤名称数据
      this.userMembenNames = this.userMembenNames.filter((v) => {
        return v.id != data.id;
      });
      this.showParams.userId = this.showParams.userId.filter((v) => {
        return v != data.id;
      });
    },
    // 开启选择成员弹窗
    clickAddMember() {
      this.dialogVisibleTree = true;
    },
    open(data) {
      if (data && data != null) {
        // 编辑
        this.type = 2;
        this.showParams = JSON.parse(JSON.stringify(data));
        let userIds = JSON.parse(JSON.stringify(this.showParams.userId));
        this.userMenberList = this.allStaff.filter((v) => {
          return userIds.includes(v.userId) == true;
        });
        this.getUsersNameData(this.userMenberList);
      } else {
        // 新增
        this.type = 1;
        this.resetParams();
      }
      this.dialogVisible = true;
    },
    // 新建分类
    addSensitiveWordType(params) {
      let that = this;
      addSensitiveWordType(params, localStorage.getItem("Authorization"))
        .then((res) => {
          if (res.error.code == 200) {
            that.$message.success("分类添加成功！");
            that.resetParams();
            this.dialogVisible = false;
            this.$emit("createSuccess", "成功");
          }
        })
        .catch((err) => {
          that.$message.error("分类添加失败，请重试！");
          console.log(err, "errr");
        });
    },
    // 编辑分类
    updateSensitiveWordType(params) {
      let that = this;
      let data = {
        wordTypeName: params.wordTypeName,
        userId: params.userId,
      };
      let type = params.wordTypeId;
      updateSensitiveWordType(data, type, localStorage.getItem("Authorization"))
        .then((res) => {
          if (res.error.code == 200) {
            that.$message.success("分类更新成功！");
            that.resetParams();
            this.dialogVisible = false;
            this.$emit("createSuccess", "成功");
          }
        })
        .catch((err) => {
          that.$message.error("分类更新失败，请重试！");
          console.log(err, "errr");
        });
    },
  },
};
</script>

<style scoped lang="scss">
/deep/ .option-dialog {
  .el-dialog__body {
    padding: 30px 20px 10px 0;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
    .xForm {
      .el-input {
        width: 80%;
      }
    }
    .el-tags-wrap {
      .el-form-item__content {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        max-height: 250px;
        overflow: auto;
        min-height: 40px;
        line-height: 150%;
        .el-tag {
          margin: 4px 4px;
        }
      }
      .tags-btn {
        padding: 0;
      }
    }
  }
}
</style>
